import { Container } from '@mui/material';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from '../store/utils';

const CustomPage = () => {
  const { tabUrl } = useParams<{ tabUrl: string }>();

  const customTabs = useSelector(
    ({ variables }) => variables.APP_UI_CUSTOM_TABS || []
  );

  const tab = customTabs.find((t) => t.url === tabUrl);

  if (!tab) {
    return <Navigate to="/" />;
  }

  return (
    <Container sx={{ display: 'flex', justifyContent: 'center', p: 0 }}>
      <iframe
        src={tab.iframeSrc}
        title={tab.label}
        style={{ width: '100%', height: '70vh', border: 'none' }}
      />
    </Container>
  );
};

export default CustomPage;
